import ThemeButton from "components/Buttons/ThemeButton";
import { styled } from "@mui/material";

export const Container = styled("div")<{ scale: number }>`
	width: 343px;
	background-color: #fff;
	border-radius: 1rem;
	position: relative;
	overflow: hidden;
	transform: scale(${(props) => props?.scale});
`;

export const Header = styled("div")<{ "data-image": string }>`
	height: 188px;
	width: 100%;
	background-repeat: no-repeat;
	background-position: cover;
	background-size: cover;
	background-position: center;
	background-image: url(${(props) => props["data-image"]});
	position: relative;
`;

export const Avatar = styled("img")`
	object-fit: contain;
	position: absolute;
	bottom: 12px;
	left: 20%;
`;

export const Tresure = styled("img")`
	object-fit: contain;
	position: absolute;
	bottom: -12px;
	left: 28%;
`;

export const Body = styled("div")`
	max-width: 372px;
	margin: 0 auto;
	padding: 1rem;
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	gap: 1rem;
`;

export const Title = styled("span")`
	font-family: "Baloo";
	font-size: 30px;
	text-align: center;
	color: #113b62;
	line-height: 28px;
`;

export const Text = styled("p")`
	font-family: "Inter";
	font-size: 16px;
	text-align: center;
	color: #333;
	margin: 0;
	line-height: 21px;
`;

export const Button = styled(ThemeButton)`
	padding: 0.5rem;
`;
